import React from 'react'

import UsageUnitTypeRendererHelper from '../../../components/AgGrid/RendererHelper/UsageUnitTypeRendererHelper'

const UsageUnitTypeRenderer = (props) => {
  return <UsageUnitTypeRendererHelper {...props} />
}

export default UsageUnitTypeRenderer
